import { useTranslation } from 'react-i18next';

interface FAQHeroProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const FAQHero = ({ searchQuery, onSearchChange }: FAQHeroProps) => {
  const { t } = useTranslation();

  return (
    <section className="relative bg-gradient-to-br from-teal-600 via-teal-500 to-emerald-500 text-white py-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/10"></div>
      
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-6">
          <i className="ri-question-answer-line text-5xl"></i>
        </div>
        
        <h1 className="text-5xl font-bold mb-4 font-['Space_Grotesk']">
          {t('faq:hero.title')}
        </h1>
        
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          {t('faq:hero.subtitle')}
        </p>

        {/* 搜索框 */}
        <div className="max-w-2xl mx-auto">
          <div className="relative">
            <div className="absolute left-5 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center">
              <i className="ri-search-line text-2xl text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={t('faq:hero.searchPlaceholder')}
              className="w-full bg-white text-gray-900 rounded-full pl-16 pr-6 py-5 text-lg shadow-2xl focus:outline-none focus:ring-4 focus:ring-white/30 transition-all"
            />
          </div>
          <p className="text-sm text-white/80 mt-4">
            {t('faq:hero.searchHint')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQHero;